export function getCustomerIP(): string {
  if (
    typeof document === 'undefined' ||
    typeof XMLHttpRequest === 'undefined'
  ) {
    return '';
  }

  try {
    const request = new XMLHttpRequest();
    request.open('GET', document.location.href, false);
    request.send(null);

    const candidateHeaders = [
      'x-client-ip',
      'x-forwarded-for',
      'true-client-ip',
      'cf-connecting-ip',
      'x-real-ip',
      'client-ip',
    ];

    const getHeaderValue = (headerName: string): string => {
      const directValue = request.getResponseHeader
        ? request.getResponseHeader(headerName)
        : null;
      if (directValue) {
        return directValue.split(',')[0].trim();
      }
      return '';
    };

    for (const headerName of candidateHeaders) {
      const value = getHeaderValue(headerName);
      if (value) {
        return value;
      }
    }

    const headers = request.getAllResponseHeaders
      ? request.getAllResponseHeaders().toLowerCase()
      : '';
    const parsedHeaders = headers.split('\n');
    const data: Record<string, string> = {};

    parsedHeaders.forEach((header) => {
      const colonIndex = header.indexOf(':');
      if (colonIndex !== -1) {
        const key = header.substring(0, colonIndex).trim();
        const value = header
          .substring(colonIndex + 1)
          .replace(/\r/g, '')
          .trim();
        if (key) {
          data[key] = value;
        }
      }
    });

    for (const headerName of candidateHeaders) {
      const headerValue = data[headerName];
      if (headerValue) {
        return headerValue.split(',')[0].trim();
      }
    }

    const cookieMatch = document.cookie.match(/(?:^|; )client_ip=([^;]*)/);
    return cookieMatch ? decodeURIComponent(cookieMatch[1]) : '';
  } catch (error) {
    console.warn('[getCustomerIP] Error retrieving client IP:', error);
    return '';
  }
}
